<template>
  <div class="centerIntro-wrap">
    <div class="centerIntro-content">
      <Breadcrumb :options="crumbOptions"></Breadcrumb>
      <div class="title">{{ dataList.title }}</div>
      <div class="activity-content">
        <div v-html="dataList.header"></div>
        <div class="activity-img">
          <img :src="dataList.headerUrl" alt="" />
        </div>
      </div>
      <!-- <div v-html="dataList.header"></div> -->
      <div class="activiyg-content-img">
        <div v-for="(item, index) in dataList.contentUrl" :key="index">
          <img :src="item" />
        </div>
      </div>
      <div v-html="dataList.footer"></div>
      <div class="activiyg-content-img">
        <div v-for="(item, index) in dataList.footerUrl" :key="index">
          <img :src="item" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from '@/components/common/Breadcrumb'
import { getResolveCrumb } from '@/utils/crumb.js'
import { competeList, activityList } from '../configs/config'

export default {
  data() {
    return {
      competeList,
      activityList,
      crumbOptions: [],
      dataList: {}
    }
  },
  components: {
    Breadcrumb
  },
  created() {
    const { id, name } = this.$route.query
    if (name === '竞赛动态') {
      this.dataList = this.competeList[id - 1]
    } else {
      this.dataList = this.activityList[id - 1]
    }
    this.settingCrumb()
  },
  methods: {
    settingCrumb() {
      const { path, query: { name } } = this.$route
      const crumbOptions = getResolveCrumb(path, name)
      this.crumbOptions = crumbOptions
    }
  }
}
</script>
